import React from 'react';
import { Box, Chip } from '@mui/material';

/**
 * Una fila di pillole mutuamente esclusive: «Tutti / Di sistema / Personalizzati».
 *
 * Esiste perché la stessa cosa era resa in due modi diversi in due tab della stessa
 * pagina — un `ButtonGroup` nei Ruoli, una fila di `Chip` nell'Audit log — e due rese per
 * un comportamento solo sono un difetto che si nota solo passando da un tab all'altro.
 *
 * `aria-pressed` non è decorazione: la selezione qui è comunicata dal colore, e il colore
 * da solo non è un'informazione. Senza quell'attributo chi naviga con una tecnologia
 * assistiva sente tre pulsanti identici.
 */
export default function FiltroPillole({ opzioni, selezione, onCambia, ariaLabel }) {
    return (
        <Box role="group" aria-label={ariaLabel} sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            {opzioni.map((opzione) => {
                const attiva = opzione.valore === selezione;
                return (
                    <Chip
                        key={opzione.valore}
                        label={opzione.etichetta}
                        clickable
                        component="button"
                        type="button"
                        aria-pressed={attiva}
                        variant="outlined"
                        // Riselezionare ciò che è già selezionato non è un cambiamento: un
                        // filtro mutuamente esclusivo non ha uno stato «nessuno», e
                        // propagarlo ricaricherebbe l'elenco per nulla.
                        onClick={() => { if (!attiva) onCambia(opzione.valore); }}
                        sx={{
                            borderRadius: 999,
                            bgcolor: attiva ? 'primary.light' : 'transparent',
                            borderColor: attiva ? 'primary.main' : 'divider',
                            color: attiva ? 'primary.main' : 'text.primary',
                        }}
                    />
                );
            })}
        </Box>
    );
}
